module.exports = __webpack_public_path__ + "static/julia-s-70a866f98402b88bde74b626933b9888.png";